import { useEffect, useState } from "react";
import API_ROUTES_V2 from "~/api-routes-v2";
import apiService from "~/services/service";

function useDocumentDescription({ data, id, type }) {
  const [shoeDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [description, setDescription] = useState("");
  const [isUpdated, setIsupdated] = useState(false);
  const [restoreMessage, setRstoreMessage] = useState("");
  const [resetDescription, setResetDescription] = useState("");
  const containerName = "document-repo";
  const handleUpdateDescription = async (blobName, description) => {
    try {
      setLoading(true);
      await apiService(
        API_ROUTES_V2.UPDATE_DESCRIPTION,
        data?.description ? "PATCH" : isUpdated ? "PATCH" : "POST",
        {
          body: {
            containerName,
            blobName,
            description: encodeURIComponent(description),
          },
          replace: { id, type },
        },
      );
      setShowDialog(false);
      setIsupdated(true);
      setRstoreMessage(
        data?.description
          ? "Description updated successfully"
          : isUpdated
            ? "Description updated successfully"
            : "Description added successfully",
      );
      setResetDescription(description);
    } catch (err) {
      console.log("Error updating description", err);
    } finally {
      setLoading(false);
    }
  };
  const safeDecode = (text) => {
    try {
      return decodeURIComponent(text);
    } catch {
      return text;
    }
  };
  return {
    shoeDialog,
    setShowDialog,
    open,
    setOpen,
    description,
    setDescription,
    handleUpdateDescription,
    isUpdated,
    setIsupdated,
    loading,
    restoreMessage,
    setRstoreMessage,
    resetDescription,
    setResetDescription,
    safeDecode,
  };
}

export default useDocumentDescription;
